import { useQuery } from 'react-query';
import { PCPSearchFormType } from '../pcpSchemas';
import { searchNpiRegistry } from './NPILookup';

type Params =
  | {
      disabled: true;
    }
  | {
      disabled?: false;
      query: PCPSearchFormType;
    };

export const useNPILookup = (params: Params) => {
  const { firstName, lastName, stateCode, city } = params.disabled ? {} : params.query;

  return useQuery(
    ['npi-lookup', firstName, lastName, stateCode, city],
    () =>
      searchNpiRegistry({
        firstName,
        lastName,
        stateCode,
        city,
      } as PCPSearchFormType),
    {
      enabled: !params.disabled,
    },
  );
};
